<template>
    <div id="v4" class="v4">
        <header-v4></header-v4>
        <router-view></router-view>
        <banAccount/>
        <img :src="src" style="width: 1px;height: 1px;opacity: 0;position: fixed;" alt="">
    </div>
</template>
<style lang="scss">
    @import '~Assets/sass/global/global.scss';
    @import '~Assets/sass/pages/v4/common/common.scss';
    @import '~Assets/sass/global/element-variables.scss';
    body{
        overflow-y: scroll !important;
        padding: 0 !important;
    }
</style>

<style lang="scss" scoped>
    .v4{
        min-height: 100vh;
        background-color: #f9f9f9;
        box-sizing: border-box;
        &::before{
            content: '';
            display: table;
        }
    }
</style>

<script>
import banAccount from 'Components/v4/pop/ban_account.vue';
import headerV4 from 'Components/v4/header/header_v4.vue';
import {
    mapGetters 
} from 'vuex';
export default {
    data() {
        return {
            src: ''
        }
    },
    components: {
        headerV4,
        banAccount
    },
    computed: {
        ...mapGetters([
            'reportNum'
        ])
    },
    mounted(){
        this.src=`//itea-stat.qq.com/tgl/stat?uid=${this.$store.state.realUserInfo.mloginName ? this.$store.state.realUserInfo.mloginName : ''}&s=${this.$common.getParams('_s') ? encodeURIComponent(this.$common.getParams('_s')) : ''}&t=${new Date().getTime()}&host=${location.host}&pathname=${location.pathname}&search=${encodeURIComponent(location.search)}&hash=${encodeURIComponent(location.hash)}`
    },
    watch: {
        reportNum (){
            this.src=`//itea-stat.qq.com/tgl/stat?uid=${this.$store.state.realUserInfo.mloginName ? this.$store.state.realUserInfo.mloginName : ''}&s=${this.$common.getParams('_s') ? encodeURIComponent(this.$common.getParams('_s')) : ''}&t=${new Date().getTime()}&host=${location.host}&pathname=${location.pathname}&search=${encodeURIComponent(location.search)}&hash=${encodeURIComponent(location.hash)}`
        }
    }
}
</script>